import { camelizeKeys } from "humps";
import * as api from "features/document/edit/partners/api";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { normalize } from "normalizr";
import { offerPartnerContactModeSchema } from "features/common/schemas";

export function loadContactModes(documentId, siteId, partnerId) {
  return async (dispatch, getState) => {
    const contactModes = getState().currentOffer.clientContactModesData[partnerId];
    let shouldCallApi = !contactModes || (!contactModes.loaded && !contactModes.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_CONTACT_MODES_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerContactModes(documentId, siteId, partnerId)));
      const result = camelizeKeys(response);
      const payload = Object.assign({}, normalize(result, [offerPartnerContactModeSchema]));
      dispatch({
        type: actionTypes.LOAD_CONTACT_MODES_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CONTACT_MODES_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function saveContactModes(documentId, siteId, partnerId, contactModes, callback = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_CONTACT_MODES_STARTED,
      payload: contactModes,
      partnerId: partnerId
    });
    const event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        api.saveContactModes(documentId, siteId, partnerId, contactModes),
        "saveContactModes",
        [eventTypes.CONTACT_MODES_UPDATED]
      )
    );
    if (event.ok) {
      const partnerContactModeIds = event.eventBody.documentPartnerContactModes.map(item => item.partnerContactModeId);
      dispatch({
        type: actionTypes.UPDATE_CONTACT_MODES_SUCCEEDED,
        contactModes: event.eventBody.documentPartnerContactModes,
        partnerId: partnerId,
        ids: partnerContactModeIds
      });
      callback();
    } else {
      dispatch({
        type: actionTypes.UPDATE_CONTACT_MODES_FAILED,
        payload: { contactModes, error: event },
        partnerId: partnerId
      });
    }
  };
}
